/* ==========================================================================
   Amalife — Program (theme-native bundle) engine.
   Progressive enhancement over snippets/ama-program-card.liquid.
   - Live total + "Спестяваш X" as shades/toggles change
   - Dye gate: blocks add-to-cart until a shade is chosen
   - One /cart/add.js call for the whole program, then re-renders Wonder's
     cart drawer via its native renderContents()
   Globals reused if present: window.routes, publish, PUB_SUB_EVENTS
   ========================================================================== */
(function () {
  "use strict";

  // Minimal Shopify money formatter (no theme global exists).
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(/[^\d.-]/g, "");
    cents = Number(cents) || 0;
    var fmt = format || "{{amount}}";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function fmtNumber(num, precision, thousands, decimal) {
      if (precision == null) precision = 2;
      if (thousands == null) thousands = ",";
      if (decimal == null) decimal = ".";
      var value = (num / 100).toFixed(precision);
      var parts = value.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var rest = parts[1] ? decimal + parts[1] : "";
      return dollars + rest;
    }

    var match = fmt.match(placeholder);
    var token = match ? match[1] : "amount";
    var out;
    switch (token) {
      case "amount": out = fmtNumber(cents, 2); break;
      case "amount_no_decimals": out = fmtNumber(cents, 0); break;
      case "amount_with_comma_separator": out = fmtNumber(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": out = fmtNumber(cents, 0, ".", ","); break;
      case "amount_with_space_separator": out = fmtNumber(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": out = fmtNumber(cents, 0, " ", ""); break;
      case "amount_with_apostrophe_separator": out = fmtNumber(cents, 2, "'", "."); break;
      default: out = fmtNumber(cents, 2);
    }
    return fmt.replace(placeholder, out);
  }

  if (customElements.get("ama-program")) return;

  customElements.define(
    "ama-program",
    class AmaProgram extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || "€{{amount}}";
        this.hasDye = this.dataset.hasDye === "true";
        this.discountPct = Number(this.dataset.discountPct) || 0;
        this.discountCode = this.dataset.discountCode || "";

        this.items = Array.prototype.slice.call(this.querySelectorAll("[data-prog-item]"));
        this.totalEl = this.querySelector("[data-prog-total]");
        this.totalWasEl = this.querySelector("[data-prog-total-was]");
        this.saveEl = this.querySelector("[data-prog-save]");
        this.saveAmtEl = this.querySelector("[data-prog-save-amt]");
        this.addBtn = this.querySelector("[data-prog-add]");
        this.hintEl = this.querySelector("[data-prog-hint]");
        this.errEl = this.querySelector("[data-prog-err]");
        this.spinner = this.querySelector(".ama-prog__spinner");

        this.dyeItem = this.items.filter(function (i) { return i.dataset.role === "dye"; })[0] || null;
        this.selectedDye = null; // { id, price, compare }

        this.bindToggles();
        this.bindShades();
        if (this.addBtn) this.addBtn.addEventListener("click", this.onAdd.bind(this));

        this.recompute();
        this.classList.add("is-ready");
      }

      bindToggles() {
        var self = this;
        this.querySelectorAll("[data-prog-toggle]").forEach(function (cb) {
          cb.addEventListener("change", function () {
            var item = cb.closest("[data-prog-item]");
            if (item) item.classList.toggle("is-excluded", !cb.checked);
            self.recompute();
          });
        });
      }

      bindShades() {
        if (!this.dyeItem) return;
        var self = this;
        var swatches = this.dyeItem.querySelectorAll("[data-prog-swatch]");
        swatches.forEach(function (sw) {
          if (sw.dataset.available !== "true") return;
          sw.addEventListener("click", function () {
            swatches.forEach(function (s) {
              s.classList.remove("is-selected");
              s.setAttribute("aria-checked", "false");
            });
            sw.classList.add("is-selected");
            sw.setAttribute("aria-checked", "true");

            self.selectedDye = {
              id: sw.dataset.variantId,
              price: Number(sw.dataset.price) || 0,
              compare: Number(sw.dataset.compare) || 0,
            };

            var caption = self.dyeItem.querySelector("[data-prog-caption]");
            if (caption) {
              caption.textContent = sw.dataset.caption || "";
              caption.classList.add("is-set");
            }
            var priceEl = self.dyeItem.querySelector("[data-prog-price] .ama-prog__amount");
            if (priceEl) priceEl.innerHTML = self.moneyDual(self.selectedDye.price);

            self.dyeItem.classList.remove("ama-prog__item--nudge");
            self.recompute();
          });
        });
      }

      isIncluded(item) {
        var cb = item.querySelector("[data-prog-toggle]");
        if (cb) return cb.checked;
        return true;
      }

      // Returns { price, compare, id, qty } for a row, or null when a dye shade
      // is required for the cart line but not yet chosen.
      lineFor(item, forCart) {
        var qty = parseInt(item.dataset.qty || "1", 10) || 1;
        if (item.dataset.role === "dye") {
          var chosen = this.selectedDye;
          if (forCart && !chosen) return null;
          var basePrice = Number(item.dataset.basePrice) || 0;
          var baseCompare = Number(item.dataset.baseCompare) || 0;
          var price = chosen ? chosen.price : basePrice;
          var compare = chosen ? chosen.compare : baseCompare;
          if (!compare) compare = price;
          return { price: price * qty, compare: compare * qty, id: chosen ? chosen.id : null, qty: qty };
        }
        var p = Number(item.dataset.price) || 0;
        var c = Number(item.dataset.compare) || 0;
        if (!c) c = p;
        return { price: p * qty, compare: c * qty, id: item.dataset.variantId, qty: qty };
      }

      recompute() {
        var total = 0;
        var finalTotal = 0;
        var compare = 0;
        var self = this;
        this.items.forEach(function (item) {
          if (!self.isIncluded(item)) return;
          var line = self.lineFor(item, false);
          if (!line) return;
          total += line.price;
          var pct = item.dataset.campaignItem === 'true' ? 0 : self.discountPct;
          finalTotal += Math.floor((line.price * (100 - pct) + 50) / 100);
          compare += line.compare;
        });
        var progDisc = total - finalTotal;
        // (window.amaI18n && window.amaI18n.you_save || "Спестяваш") = the program discount only (matches the "−X% за програмата" label
        // and the total → finalTotal delta). Per-item compare_at promos are shown on each
        // row, so they are intentionally excluded here (was: (compare - total) + progDisc,
        // which contradicted the label). `compare` stays available for future use.
        var totalSavings = progDisc;

        if (this.totalEl) this.totalEl.innerHTML = this.moneyDual(finalTotal);
        if (this.totalWasEl) {
          this.totalWasEl.innerHTML = this.moneyDual(total);
          this.totalWasEl.classList.toggle("is-hidden", progDisc <= 0);
        }
        if (this.saveEl) {
          this.saveEl.classList.toggle("is-hidden", totalSavings <= 0);
          if (this.saveAmtEl) this.saveAmtEl.innerHTML = this.moneyDual(totalSavings);
        }
        this.updateGate();
      }

      updateGate() {
        var self = this;
        var needsShade = this.hasDye && !this.selectedDye;

        var includedRows = this.items.filter(function (i) { return self.isIncluded(i); });
        var anyIncluded = includedRows.length > 0;

        // a required (non-optional) included row that is sold out blocks the add
        var soldOutRequired = includedRows.some(function (i) {
          return i.dataset.role !== "dye" && i.dataset.optional !== "true" && i.dataset.available === "false";
        });

        var blocked = needsShade || !anyIncluded || soldOutRequired;

        if (this.addBtn) {
          // NB: set the attribute to the literal "true"/remove it — toggleAttribute would
          // write an empty string, which the onAdd guard (=== "true") would never match.
          if (blocked) { this.addBtn.setAttribute("aria-disabled", "true"); }
          else { this.addBtn.removeAttribute("aria-disabled"); }
          this.addBtn.classList.toggle("is-disabled", blocked);
        }
        if (this.hintEl) {
          if (soldOutRequired && !needsShade) {
            this.hintEl.textContent = (window.amaI18n && window.amaI18n.required_sold_out || "Някои задължителни продукти са изчерпани.");
            this.hintEl.classList.remove("is-hidden");
          } else if (needsShade) {
            this.hintEl.textContent = (window.amaI18n && window.amaI18n.shade_first || "Първо избери нюанс на боята, за да добавиш програмата.");
            this.hintEl.classList.remove("is-hidden");
          } else {
            this.hintEl.classList.add("is-hidden");
          }
        }
      }

      onAdd() {
        // Guard off the class (always reliably set in updateGate), not the attribute string.
        if (this.addBtn && this.addBtn.classList.contains("is-disabled")) {
          // Nudge the shade picker when that's what's missing.
          if (this.hasDye && !this.selectedDye && this.dyeItem) {
            this.dyeItem.classList.add("ama-prog__item--nudge");
            var shades = this.dyeItem.querySelector("[data-prog-shades]");
            if (shades && shades.scrollIntoView) shades.scrollIntoView({ behavior: "smooth", block: "center" });
            var self = this;
            setTimeout(function () { self.dyeItem.classList.remove("ama-prog__item--nudge"); }, 1400);
          }
          return;
        }

        var items = [];
        var self = this;
        this.items.forEach(function (item) {
          if (!self.isIncluded(item)) return;
          var line = self.lineFor(item, true);
          if (!line || !line.id) return;
          items.push({ id: Number(line.id), quantity: line.qty });
        });
        if (!items.length) return;

        this.setLoading(true);
        if (this.errEl) this.errEl.hidden = true;

        var cart = document.querySelector("cart-drawer");
        var sectionIds = cart && typeof cart.getSectionsToRender === "function"
          ? cart.getSectionsToRender().map(function (s) { return s.id; })
          : [];

        var body = { items: items };
        if (sectionIds.length) {
          body.sections = sectionIds.join(",");
          body.sections_url = window.location.pathname;
        }

        var url = (window.routes && window.routes.cart_add_url) || "/cart/add.js";

        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) {
              self.showError(res.description || res.message || (window.amaI18n && window.amaI18n.add_error || "Възникна грешка при добавянето."));
              return;
            }
            // Apply the program discount code (shows at cart/checkout). Fire-and-forget.
            if (self.discountCode) {
              fetch("/discount/" + encodeURIComponent(self.discountCode) + "?redirect=/cart.js", {
                headers: { Accept: "application/json" },
              }).catch(function () {});
            }
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "ama-program", cartData: res, addedQuantities: items });
            }
            if (cart && typeof cart.renderContents === "function" && res.sections) {
              // Open the drawer when it's closed; when adding from inside the
              // already-open drawer (cart upsell), don't toggle it shut.
              var isClosedCart = !document.body.classList.contains("page-overlay-cart-on");
              cart.renderContents(res, isClosedCart);
            } else {
              window.location = (window.routes && window.routes.cart_url) || "/cart";
            }
          })
          .catch(function () {
            self.showError((window.amaI18n && window.amaI18n.add_retry || "Възникна грешка при добавянето. Опитай отново."));
          })
          .finally(function () {
            self.setLoading(false);
          });
      }

      showError(msg) {
        if (!this.errEl) return;
        this.errEl.textContent = msg;
        this.errEl.hidden = false;
      }

      setLoading(on) {
        if (this.addBtn) {
          this.addBtn.classList.toggle("is-loading", on);
          this.addBtn.toggleAttribute("aria-busy", on);
        }
        if (this.spinner) this.spinner.hidden = !on;
      }

      money(cents) {
        return formatMoney(cents, this.moneyFormat);
      }
      /* Euro only, matching snippets/ama-price-dual.liquid — the lev half was
         dropped on client request. The method keeps its name so the four call
         sites that repaint totals as the shopper edits a program stay put. */
      moneyDual(cents) {
        return '<span class="ama-price__eur">' + this.money(cents) + "</span>";
      }
    }
  );
})();
